<template>
  <connection-error
    v-if="!signedRequest"
    :error="$t('slackConnect.missingRequest')"
    @exit="goHome"
  />
  <integration-connect-card
    v-else
    logo-icon="slack"
    :title="$t('slackConnect.title')"
    :body="$t('slackConnect.body')"
    :permissions-heading="$t('slackConnect.permissionsHeading')"
    :permissions="permissions"
    :allow-label="$t('slackConnect.allow')"
    :cancel-label="$t('slackConnect.cancel')"
    :loading="loading"
    @allow="allowAccess"
    @cancel="goHome"
  />
</template>

<script setup>
import ConnectionError from '@/components/slack/ConnectionError.vue';
import IntegrationConnectCard from '@/components/integrations/IntegrationConnectCard.vue';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const signedRequest = computed(() => route.query.slack_connect_request);

const permissions = [
  { icon: 'eye', text: t('slackConnect.permissions.readGoals') },
  { icon: 'goals', text: t('slackConnect.permissions.updateGoals') },
  { icon: 'bell', text: t('slackConnect.permissions.notifications') },
];

const loading = ref(false);

const allowAccess = (account) => {
  if (!signedRequest.value) {
    return;
  }
  loading.value = true;
  const params = new URLSearchParams({ s: signedRequest.value });
  if (account?.uid) {
    params.set('accountId', String(account.uid));
  }
  window.location.href = `/api/v1/slack-bot/connect?${params.toString()}`;
};

const goHome = () => {
  router.push('/');
};
</script>
